import React, {Component} from 'react';
import Menu from "../components/Menu";
import {Link} from "react-router-dom";
import Axios from "axios";
import AppUrl from "../AppUrl/ApiUrl";
import moment from "moment";
import {toast} from "react-toastify";
import Loading from "../components/Loading";

export function TimeAgo(date) {
    if (!date) return date;
    return moment.utc(date).local().fromNow();
}

class AirdropUsers extends Component {
    constructor() {
        super();
        this.state={
            data: [],
            token: "",
            name: "",
            loading: true,
            count: 50,
            total: 0
        }
    }

    componentDidMount() {
        var token = localStorage.getItem("admintoken")
        this.setState({token: token})

        var limit = this.state.count;
        var formd = new FormData()
        formd.append("limit", limit)

        Axios.post(AppUrl.baseurl + "airdropall", formd)
            .then(res => {
                if(res.data.error){
                    this.setState({loading: false})
                } else {
                    this.setState({
                        data: res.data.data,
                        total: res.data.total_count,
                        loading: false
                    })
                }
            })
            .catch(err => {
                console.log(err)
                this.setState({loading: false})
            })
    }

    onName = (e) => {
        this.setState({name: e.target.value})
    }

    onDel = (id) => {
        var confirm = window.confirm("Are you sure to delete this airdrop entry?")
        const FormDa = new FormData()
        FormDa.append('token', this.state.token)
        FormDa.append('id', id)

        if(confirm){
            Axios.post(AppUrl.baseurl + "delete-airdrop", FormDa) // আপনার ব্যাকএন্ড ডিলিট রুট অনুযায়ী পরিবর্তন করতে পারেন
                .then(res => {
                    if(res.data.success){
                        this.componentDidMount()
                        toast.success(res.data.success, {
                            position: "top-right",
                            autoClose: 5000,
                        });
                    } else {
                        toast.error(res.data.error, {
                            position: "top-right",
                            autoClose: 5000,
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

    loadMore = (e) => {
        var countval = this.state.count + 50
        this.setState({count: countval, loading: true})
        setTimeout(() => {
            this.componentDidMount()
        }, 500)
    }

    render() {
        const data = this.state.data.map((res, index) => {
            return(
                <tr key={res.id || index}>
                    <td>{res.id}</td>
                    <td>{res.uid}</td>
                    <td>{res.telegram || "N/A"}</td>
                    <td>{res.telegram2 || "N/A"}</td>
                    <td>{res.twitter || "N/A"}</td>
                    <td>{res.created_at ? TimeAgo(res.created_at) : "N/A"}</td>
                    <td style={{width: "100px"}}>
                        <button className="btn btn-danger btn-sm rounded-0 shadow-none" type="button"
                                title="Delete" onClick={this.onDel.bind(this, res.id)}>
                            <i className="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            )
        })

        return (
            <Menu title={"Airdrop Users"}>
                <h3 className="bg-white title-head"> Total Airdrop Users ({this.state.total}) </h3>
                <div className="container-fluid currency">
                    <div className="row">
                        <div className="col-md-12 p-0 m-0">
                            <div className="list bg-white p-2">
                                <div className="table-responsive mt-3">
                                    <table className="table table-bordered bg-white">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>UID</th>
                                            <th>Telegram Channel</th>
                                            <th>Telegram Group</th>
                                            <th>Twitter</th>
                                            <th>Created At</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.loading === true ? (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    <Loading />
                                                </td>
                                            </tr>
                                        ) : data.length > 0 ? data : (
                                            <tr>
                                                <td colSpan="7" className="text-center">No airdrop users found.</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.total > this.state.count ?
                        <div className="row" style={{margin: "0"}}>
                            <div className="col-md-12 loadmore text-center mt-3">
                                <button onClick={this.loadMore} className="btn btn-secondary btn-sm mb-3 shadow-none">
                                    Load more ...
                                </button>
                            </div>
                        </div> : ""
                }
            </Menu>
        );
    }
}

export default AirdropUsers;